document.addEventListener('DOMContentLoaded', function () {
  var banner = document.querySelector('[data-cookie-banner]');
  if (!banner) return;
  var saved = localStorage.getItem('cs_cookie_consent');
  if (!saved) banner.hidden = false;

  var accept = banner.querySelector('[data-cookie-accept]');
  var reject = banner.querySelector('[data-cookie-reject]');
  if (accept) accept.addEventListener('click', function () {
    localStorage.setItem('cs_cookie_consent', 'accepted');
    banner.hidden = true;
  });
  if (reject) reject.addEventListener('click', function () {
    localStorage.setItem('cs_cookie_consent', 'rejected');
    banner.hidden = true;
  });
});
